const USER_GENDER_ENUM = Object.freeze({
    MALE: 0,
    FEMALE: 1,
  });
  
  export default USER_GENDER_ENUM;
  